// Gonini brand palette (Brand Guidelines 2026). Keep in sync with scss/_colors.scss.
export const goniniBlue = {
	50: "#d6dbe6",
	100: "#bbc3d6",
	200: "#99a5c1",
	300: "#7687ac",
	400: "#546998",
	500: "#324b83",
	600: "#2a3f6d",
	700: "#213257",
	800: "#192642",
	900: "#11192c",
	950: "#0a0f1a",
};

export const goniniGreen = {
	50: "#d7f5e6",
	100: "#bdeed5",
	200: "#9ce6c0",
	300: "#7adeab",
	400: "#59d596",
	500: "#38cd81",
	600: "#2fab6c",
	700: "#258956",
	800: "#1c6741",
	900: "#13442b",
	950: "#0b291a",
};

export const goniniOrange = {
	50: "#ffebd4",
	100: "#ffdeb8",
	200: "#ffcd94",
	300: "#ffbc70",
	400: "#ffac4d",
	500: "#ff9b29",
	600: "#d58122",
	700: "#aa671b",
	800: "#804e15",
	900: "#55340e",
	950: "#331f08",
};

export const goniniFontFamily = "\"Geist Variable\", \"Helvetica Neue\", Helvetica, Arial, sans-serif";

export const goniniRed = "rgba(161,51,51,1)";
